import Elite_Room01 from "../Images/room/EliteRoom/Elite-Room01.webp";
import Elite_Room02 from "../Images/room/EliteRoom/Elite-Room02.webp";
import Elite_Room03 from "../Images/room/EliteRoom/Elite-Room03.webp";
import Elite_Room05 from "../Images/room/EliteRoom/Elite-Room05.webp";
import Elite_Room06 from "../Images/room/EliteRoom/Elite-Room06.webp";

import Deluxe_Premium_Couple_Cottages01 from "../Images/room/DeluxePremiumCoupleCottages/Deluxe-Premium-Couple-Cottages01.webp";
import Deluxe_Premium_Couple_Cottages02 from "../Images/room/DeluxePremiumCoupleCottages/Deluxe-Premium-Couple-Cottages02.webp";
import Deluxe_Premium_Couple_Cottages03 from "../Images/room/DeluxePremiumCoupleCottages/Deluxe-Premium-Couple-Cottages03.webp";
import Deluxe_Premium_Couple_Cottages04 from "../Images/room/DeluxePremiumCoupleCottages/Deluxe-Premium-Couple-Cottages04.webp";

import Super_Deluxe_Cottage_01 from "../Images/room/SuperDeluxeCottage/Super-Deluxe-Cottage01.webp";
import Super_Deluxe_Cottage_02 from "../Images/room/SuperDeluxeCottage/Super-Deluxe-Cottage02.webp";
import Super_Deluxe_Cottage_03 from "../Images/room/SuperDeluxeCottage/Super-Deluxe-Cottage03.webp";
import Super_Deluxe_Cottage_04 from "../Images/room/SuperDeluxeCottage/Super-Deluxe-Cottage04.webp";
import Super_Deluxe_Cottage_05 from "../Images/room/SuperDeluxeCottage/Super-Deluxe-Cottage05.webp";

import Deluxe_premium_Family_Cottages01 from "../Images/room/DeluxepremiumFamilyCottages/Deluxe-premium-Family-Cottages01.webp";
import Deluxe_premium_Family_Cottages02 from "../Images/room/DeluxepremiumFamilyCottages/Deluxe-premium-Family-Cottages02.webp";
import Deluxe_premium_Family_Cottages03 from "../Images/room/DeluxepremiumFamilyCottages/Deluxe-premium-Family-Cottages03.webp";
import Deluxe_premium_Family_Cottages04 from "../Images/room/DeluxepremiumFamilyCottages/Deluxe-premium-Family-Cottages04.webp";

import Family_Executive_Room01 from "../Images/room/FamilyExecutive/Family-Executive-Room01.webp";
import Family_Executive_Room02 from "../Images/room/FamilyExecutive/Family-Executive-Room02.webp";
import Family_Executive_Room03 from "../Images/room/FamilyExecutive/Family-Executive-Room03.webp";
import Family_Executive_Room04 from "../Images/room/FamilyExecutive/Family-Executive-Room04.webp";
import Family_Executive_Room05 from "../Images/room/FamilyExecutive/Family-Executive-Room05.webp";

import Deluxe_Quad_Rooms01 from "../Images/room/DeluxeQuad/Deluxe-Quad-Rooms01.jpg";
import Deluxe_Quad_Rooms02 from "../Images/room/DeluxeQuad/Deluxe-Quad-Rooms02.jpg";
import Deluxe_Quad_Rooms03 from "../Images/room/DeluxeQuad/Deluxe-Quad-Rooms03.jpg";
import Deluxe_Quad_Rooms04 from "../Images/room/DeluxeQuad/Deluxe-Quad-Rooms04.jpg";
import Deluxe_Quad_Rooms05 from "../Images/room/DeluxeQuad/Deluxe-Quad-Rooms05.jpg";

import Dormitory01 from "../Images/room/Dormitory/Dormitory01.jpg";
import Dormitory02 from "../Images/room/Dormitory/Dormitory02.jpg";
import Dormitory03 from "../Images/room/Dormitory/Dormitory03.jpg";

import Studiofamilyroom01 from "../Images/room/StudioFamilyRoom/Studio-family-room01.jpg";
import Studiofamilyroom02 from "../Images/room/StudioFamilyRoom/Studio-family-room02.jpg";
import Studiofamilyroom03 from "../Images/room/StudioFamilyRoom/Studio-family-room03.jpg";
import Studiofamilyroom04 from "../Images/room/StudioFamilyRoom/Studio-family-room04.jpg";

const RoomData = [
    {
      room_id: "1",
      slug: "/elite-room-in-neral",
      roomName: "Elite Room",
      roomImageData: [
        { roomImage: Elite_Room01 },
        { roomImage: Elite_Room02 },
        { roomImage: Elite_Room03 },
        // { roomImage: Elite_Room04 },
        { roomImage: Elite_Room05 },
        { roomImage: Elite_Room06 }
      ],
      roomPrice: "3000 - 3500",
      roomBed: "1",
      roomMax_Guests: "2",
      roomShort_Des: [
        "The Elite Room at Seema Resort, Neral is a perfect choice for couples and solo travelers looking for a peaceful stay near Mumbai and Pune. Located amidst lush greenery of the Western Ghats, these rooms offer comfort, privacy, and scenic surroundings.",
        "Each Elite Room (S1–S4) is thoughtfully designed with a comfortable king-size bed, clean interiors, modern washrooms, and calming views that help you relax and unwind during your stay.",
        "Guests can opt for the CP plan with breakfast at ₹3500 or choose the room-only option at ₹3000. Ideal for short weekend getaways, romantic stays, or leisure travel in Neral."
      ]
    },
  
    {
      room_id: "2",
      slug: "/deluxe-premium-couple-cottage-in-neral",
      roomName: "Deluxe Premium Couple Cottage",
      roomImageData: [
        { roomImage: Deluxe_Premium_Couple_Cottages01 },
        { roomImage: Deluxe_Premium_Couple_Cottages02 },
        { roomImage: Deluxe_Premium_Couple_Cottages03 },
        { roomImage: Deluxe_Premium_Couple_Cottages04 },
      ],
      roomPrice: "3500 - 4000",
      roomBed: "1",
      roomMax_Guests: "2",
      roomShort_Des: [
        "The Deluxe Premium Couple Cottage at Seema Resort is specially crafted for couples seeking privacy, romance, and comfort in Neral. These exclusive cottages (C1–C2) are surrounded by nature, making them ideal for honeymooners and romantic escapes.",
        "Each cottage features a spacious bedroom, elegant décor, attached bathroom, and a cozy ambiance that enhances the overall stay experience.",
        "The CP plan is available at ₹4000, while the special couple final rate is ₹3800. This cottage is perfect for anniversaries, weekend trips, and peaceful couple retreats near Mumbai."
      ]
    },
  
    {
      room_id: "3",
      slug: "/super-deluxe-cottage-in-neral",
      roomName: "Super Deluxe Cottage",
      roomImageData: [
        { roomImage: Super_Deluxe_Cottage_01 },
        { roomImage: Super_Deluxe_Cottage_02 },
        { roomImage: Super_Deluxe_Cottage_03 },
        { roomImage: Super_Deluxe_Cottage_04 },
        { roomImage: Super_Deluxe_Cottage_05 }
      ],
      roomPrice: "4000 - 4500",
      roomBed: "1",
      roomMax_Guests: "2",
      roomShort_Des: [
        "Super Deluxe Cottages at Seema Resort, Neral offer premium comfort with a perfect balance of luxury and nature. Located in a quiet area of the resort, these cottages (S7–S9) are ideal for couples and premium travelers.",
        "The rooms are spacious, well-ventilated, and equipped with modern amenities to ensure a comfortable and relaxing stay experience.",
        "With a final applicable rate of ₹4200, these cottages are ideal for guests looking for an upscale stay with scenic views and easy access to resort facilities."
      ]
    },
  
    {
      room_id: "4",
      slug: "/deluxe-premium-family-cottage-in-neral",
      roomName: "Deluxe Premium Family Cottage",
      roomImageData: [
        { roomImage: Deluxe_premium_Family_Cottages01 },
        { roomImage: Deluxe_premium_Family_Cottages02 },
        { roomImage: Deluxe_premium_Family_Cottages03 },
        { roomImage: Deluxe_premium_Family_Cottages04 },

      ],
      roomPrice: "4000 - 4500",
      roomBed: "2",
      roomMax_Guests: "4",
      roomShort_Des: [
        "The Deluxe Premium Family Cottage at Seema Resort, Neral is designed for families and small groups looking for a comfortable and spacious stay amidst nature.",
        "These cottages (C3–C5) provide ample space, multiple beds, and a relaxing environment suitable for family vacations, celebrations, and group travel.",
        "With a final rate of ₹4200, these family cottages offer excellent value for money while ensuring privacy, comfort, and a memorable resort experience."
      ]
    },
  
    {
      room_id: "5",
      slug: "/family-executive-in-neral",
      roomName: "Family Executive",
      roomImageData: [
        { roomImage: Family_Executive_Room01 },
        { roomImage: Family_Executive_Room02 },
        { roomImage: Family_Executive_Room03 },
        { roomImage: Family_Executive_Room04 },
        { roomImage: Family_Executive_Room05 }
      ],
      roomPrice: "5000",
      roomBed: "Bed to Bed",
      roomMax_Guests: "4",
      roomShort_Des: [
        "Family Executive Rooms at Seema Resort are located in the main building and are perfect for families seeking convenience and comfort.",
        "These rooms (101–204) follow a bed-to-bed accommodation concept with additional mattress arrangements, making them suitable for families with children.",
        "Priced at ₹5000, these rooms are ideal for long stays, family vacations, and comfortable group accommodation in Neral."
      ]
    },
  
    {
      room_id: "6",
      slug: "/deluxe-quad-room-stone-hill-in-neral",
      roomName: "Deluxe Quad Room Cottage (Stone Hill)",
      roomImageData: [
        { roomImage: Deluxe_Quad_Rooms01 },
        { roomImage: Deluxe_Quad_Rooms02 },
        { roomImage: Deluxe_Quad_Rooms03 },
        { roomImage: Deluxe_Quad_Rooms04 },
        { roomImage: Deluxe_Quad_Rooms05 }
      ],
      roomPrice: "5500 / 2500 per person",
      roomBed: "4",
      roomMax_Guests: "4",
      roomShort_Des: [
        "The Deluxe Quad Room Cottage at Stone Hill, Seema Resort, is perfect for groups and friends traveling together.",
        "These cottages (C6–C9) offer quad-sharing accommodation with comfortable bedding and scenic surroundings.",
        "Guests can opt for ₹2500 per person pricing, making it an affordable and popular choice for group outings and weekend trips near Mumbai."
      ]
    },
  
    {
      room_id: "7",
      slug: "/dormitory-in-neral",
      roomName: "Dormitory",
      roomImageData: [
        { roomImage: Dormitory01 },
        { roomImage: Dormitory02 },
        { roomImage: Dormitory03 },
      ],
      roomPrice: "8000 - 10000",
      roomBed: "Bed to Bed",
      roomMax_Guests: "15",
      roomShort_Des: [
        "The Dormitory at Seema Resort, Neral is ideal for large groups, corporate outings, school trips, and adventure camps.",
        "Dormitory rooms (D1–D2) can accommodate up to 15 guests with mattress arrangements, ensuring comfort for group stays.",
        "With a final group rate of ₹8000, this option offers budget-friendly accommodation while enjoying resort amenities and natural surroundings."
      ]
    },
    {
      room_id: "8",
      slug: "/studio-family-room ",
      roomName: "Studio Family Room",
      roomImageData: [
        { roomImage: Studiofamilyroom01 },
        { roomImage: Studiofamilyroom02 },
        { roomImage: Studiofamilyroom03 },
        { roomImage: Studiofamilyroom04 },
      ],
      roomPrice: "8000",
      roomBed: "Bed to Bed",
      roomMax_Guests: "15",
      roomShort_Des: [
        "Perfect for families or small groups, the Studio Family Room at Seema Resort, Neral offers a comfortable and cozy stay surrounded by nature.",
        "The room accommodates up to 15 guests with spacious bedding arrangements, making it ideal for group getaways or extended family stays.",
        "Enjoy resort amenities and a relaxing atmosphere at an affordable rate of ₹8000, ensuring a memorable and budget-friendly experience."
      ]
    }
  ];
  
  export default RoomData;